export class Link {
  constructor(
    public readonly download: string,
    public readonly web: string,
  ) {
  }
}